import { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import useAccountQuery from 'api/queries/useAccountQuery';
import useSelectionsQuery from 'api/queries/useSelectionsQuery';
import { JoinModal } from 'features/paid-membership/JoinModal';
import Button from 'honeydew/Button';
import { useAccountPlusMembershipHook } from 'hooks/useAccountPlusMembershipHook';
import { getCartMemberSavings, getGroceryMinMet } from 'utils/priceUtils';

function PlusMembershipStickyBanner({ hide }) {
    const [modalOpen, setModalOpen] = useState(false);

    const { data: account = {} } = useAccountQuery();
    const { data: selections = {} } = useSelectionsQuery();

    const { availableTrialMembership, plusMembershipBranding } = useAccountPlusMembershipHook();

    const groceryMinMet = getGroceryMinMet({ account, selections });

    const cartMemberSavings = getCartMemberSavings({ account, selections });

    if (!groceryMinMet || cartMemberSavings <= 0) {
        return false;
    }

    return (
        <div className={clsx('sticky bottom-0 z-10', { 'overflow-hidden': hide })}>
            <div
                className={clsx('relative overflow-hidden rounded-t-lg bg-malt p-5 pt-10 transition if:bg-oat', {
                    'translate-y-full': hide,
                })}
            >
                <div className="absolute left-0 top-0 z-10 h-5 w-full bg-gradient-berry-blend" />
                <div className="flex items-center justify-between gap-5">
                    <div className="text-body-sm flex flex-col">
                        <p className="font-grotesk-bold">
                            Save an extra <span className="text-cranberry">${cartMemberSavings.toFixed(2)}</span> on
                            this order by signing up for {plusMembershipBranding}
                        </p>
                    </div>
                    <Button
                        customClass="text-body-xs h-40 min-w-70 whitespace-nowrap rounded-full px-10"
                        onClick={() => setModalOpen(true)}
                        size="custom"
                        variant="plusMembership"
                    >
                        {availableTrialMembership ? 'Try Free' : 'Join'}
                    </Button>
                </div>
            </div>
            <JoinModal onClose={() => setModalOpen(false)} open={modalOpen} />
        </div>
    );
}

PlusMembershipStickyBanner.propTypes = {
    hide: PropTypes.bool.isRequired,
};

export { PlusMembershipStickyBanner };
